import { callAPI } from "utils/API";
import Activity from "./Activity";

export const addProductToBasket = async (ShopID, ProductID, VariationID, amount, userNote='') => {
    const basketInfo = await callAPI('/basket', 'POST', {body:{ShopID, ProductID, VariationID, amount, userNote}})
    Activity({activityType: 'click', activityName: 'product', activityArgument: 'Basket', activityArgumentID: ProductID})
    return basketInfo
}

export const addPackageToBasket = async (ShopID, ProductPackageID, amount, userNote='') => {
    const basketInfo = await callAPI('/basket', 'POST', {body: {ShopID, ProductPackageID, amount, userNote}})
    Activity({activityType: 'click', activityName: 'package', activityArgument: 'Basket', activityArgumentID: ProductPackageID})
    return basketInfo
}

export const removeProductFromBasket = async (BasketID) => {
    const basketInfo = await callAPI(`/basket/${BasketID}`, 'DELETE')
    return basketInfo
}

export const updateProductQuantityInBasket = async (BasketID, amount) => {
    const basketInfo = await callAPI(`/basket/${BasketID}/updateQuantity`, 'POST', {body:{amount}})
    Activity({activityType: 'click', activityName: 'basket', activityArgument: 'Update', activityArgumentID: BasketID})
    return basketInfo
}

export const basketHasRoomforMoreProducts = (basket, shop) => {
    const productShopSelectionLimit = shop?.shopSelectionLimit || 0
    if (productShopSelectionLimit === 0) {
        return true
    }
    if (productShopSelectionLimit > 0 && shop) {
        const basketShop = basket.filter(basketItem => basketItem.ShopID === shop.ShopID)
        if (basketShop && basketShop.length >= productShopSelectionLimit) {
            return false
        }
    }
    return true
}

export const isOrderLimitExhausted = (shop) => {
    if(!shop?.ShopID) return true // Invalid Shop - prevent placing order
    return !shop?.shopSelectionLimit || !shop?.orderCount
        ? false
        : shop?.orderCount >= shop?.shopSelectionLimit
}
